import { create } from "zustand";

export enum ModalType {
  DOWNLOAD_APP = "downloadApp",
}

interface ModalStore {
  modal: ModalType | undefined;
  setModal: (modal: ModalType) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  modal: undefined,
  setModal: (modal: ModalType) => set({ modal }),
  closeModal: () => set({ modal: undefined }),
}));

export const useModal = () => {
  const store = useModalStore();

  return {
    modal: store.modal,
    setModal: store.setModal,
    closeModal: store.closeModal,
  };
};
